import { render, staticRenderFns } from "./JNJPersonal.vue?vue&type=template&id=680bbe82&scoped=true&"
import script from "./JNJPersonal.vue?vue&type=script&lang=js&"
export * from "./JNJPersonal.vue?vue&type=script&lang=js&"
import style0 from "./JNJPersonal.vue?vue&type=style&index=0&id=680bbe82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680bbe82",
  null
  
)

export default component.exports